import React from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[HCEN]', error, info);
  }

  render() {
    const { error } = this.state;
    const { fallback = '/manager/dashboard', title = 'Something went wrong' } = this.props;

    if (error) {
      return (
        <div className="page">
          <div className="page-body">
            <div className="card" style={{ maxWidth: 520, margin: '24px auto' }}>
              <h2>{title}</h2>
              <p className="hint">{error.message || 'This page could not load. Your login is still valid.'}</p>
              <div className="row-actions mt">
                <Link to={fallback} className="btn btn-primary" onClick={() => this.setState({ error: null })}>
                  Go to dashboard
                </Link>
                <button type="button" className="btn btn-secondary" onClick={() => window.location.reload()}>
                  Reload page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
